/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmTrasaProTypDokumentu extends GContentBase<SeznamAdmTrasaProTypDokumentuObj> {
        private seznamObj: SeznamAdmTrasaProTypDokumentuObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmTrasaProTypDokumentuObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmTrasaProTypDokumentuNew",
                contentCaption: "jres:33000831", //RC 33000831 : Typy dokument� pro trasy
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_tra_txt} - {ixs_typ_txt}"
                },
                gridSettings: {
                    columnOrder: `${(this.ixs_tra == null || this.ixs_tra == undefined) ? "ixs_tra_txt," : ""}ixs_typ_txt,poznamka,dat_zmena,zmenu_prov_txt`
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmTrasaProTypDokumentuObj extends GAdmSeznamBase {
        ixs_tra: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmTrasaProTypDokumentu", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmTrasaProTypDokumentu",
                newRecord: isNew,
                ixs_tra: isNew == true ? ((this.ixs_tra) ? this.ixs_tra : null) : data.ixs_tra,
                ixs_typ: isNew == true ? null : data.ixs_typ
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                "actOpenDialogVyberovaSkupina*"
            ])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:33000798").addField("gselectbox", Gordic.Prefabs.Select.wflstra(), {
                dropdown: true,
                model: "model.ixs_tra=value.ixs_tra",
                name: "ixs_tra",
                disabled: (this.ixs_tra) ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_tra)
               hardFilter["ixs_tra"] = this.ixs_tra
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs_tra)
                data["ixs_tra"] = this.ixs_tra
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmTrasaProTypDokumentu.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_tra}#${data.ixs_typ}#`,
                nazev: `${data["ixs_tra_txt"]} - ${data["ixs_typ_txt"]}` 
            }
        }
    }
}